/**
 * Optimized Age Verification Popup
 * Performance improvements: lazy loading, better caching, reduced API calls
 */

(function() {
  'use strict';
  
  // Always initialize header state display first
  function initHeaderStateAlways() {
    const currentState = localStorage.getItem('currentState');
    if (currentState) {
      updateHeaderStateAlways();
    }
  }

  function updateHeaderStateAlways() {
    const statesCode = {
      "Alabama":"AL", "Alaska":"AK", "Arizona":"AZ", "Arkansas":"AR", "California":"CA",
      "Colorado":"CO", "Connecticut":"CT", "Delaware":"DE", "District of Columbia":"DC",
      "Florida":"FL", "Georgia":"GA", "Hawaii":"HI", "Idaho":"ID", "Illinois":"IL",
      "Indiana":"IN", "Iowa":"IA", "Kansas":"KS", "Kentucky":"KY", "Louisiana":"LA",
      "Maine":"ME", "Maryland":"MD", "Massachusetts":"MA", "Michigan":"MI", "Minnesota":"MN",
      "Mississippi":"MS", "Missouri":"MO", "Montana":"MT", "Nebraska":"NE", "Nevada":"NV",
      "New Hampshire":"NH", "New Jersey":"NJ", "New Mexico":"NM", "New York":"NY",
      "North Carolina":"NC", "North Dakota":"ND", "Ohio":"OH", "Oklahoma":"OK", "Oregon":"OR",
      "Pennsylvania":"PA", "Rhode Island":"RI", "South Carolina":"SC", "South Dakota":"SD",
      "Tennessee":"TN", "Texas":"TX", "Utah":"UT", "Vermont":"VT", "Virginia":"VA",
      "Washington":"WA", "West Virginia":"WV", "Wisconsin":"WI", "Wyoming":"WY"
    };
    
    const currentState = localStorage.getItem('currentState');
    const headerStateWrapper = document.querySelector('.state-wrapper');
    
    if (currentState && headerStateWrapper && statesCode[currentState]) {
      headerStateWrapper.innerHTML = statesCode[currentState];
    }
  }

  // Run header state initialization immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderStateAlways);
  } else {
    initHeaderStateAlways();
  }

  // Performance optimization: Check cookie first, avoid DOM manipulation if not needed
  const isAdult = document.cookie.match(/isAnAdult=true/);
  
  if (isAdult) {
    return; // Exit early if already verified
  }

  // Lazy load the popup HTML and CSS only when needed
  function initAgeCheck() {
    // Create optimized popup HTML
    const popupHTML = `
      <div id="prompt-background" style="display:block;">
        <div id="age-check-prompt" class="modal-prompt">
          <div class="age_popup_title">Age Verification</div>
          <p class="adult_text">You must be <span>21</span> years old to enter.</p>
          <div class="btn-col">
            <button id="submit_birthdate" class="button-enter">Yes</button> 
            <button id="under_button" class="">No</button> 
          </div>
          <state-estimator id="popup-states" class="flex-row" data-state="">
            <div id="state-province-wrapper" class="input">
              <div class="select-wrapper">
                <select class="select us_state_selector" id="popup_state_selector" name="state[province]">
                  <option value="Alabama">Alabama</option>
                  <option value="Alaska">Alaska</option>
                  <option value="Arizona">Arizona</option>
                  <option value="Arkansas">Arkansas</option>
                  <option value="California">California</option>
                  <option value="Colorado">Colorado</option>
                  <option value="Connecticut">Connecticut</option>
                  <option value="Delaware">Delaware</option>
                  <option value="District of Columbia">Washington DC</option>
                  <option value="Florida">Florida</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Hawaii">Hawaii</option>
                  <option value="Idaho">Idaho</option>
                  <option value="Illinois">Illinois</option>
                  <option value="Indiana">Indiana</option>
                  <option value="Iowa">Iowa</option>
                  <option value="Kansas">Kansas</option>
                  <option value="Kentucky">Kentucky</option>
                  <option value="Louisiana">Louisiana</option>
                  <option value="Maine">Maine</option>
                  <option value="Maryland">Maryland</option>
                  <option value="Massachusetts">Massachusetts</option>
                  <option value="Michigan">Michigan</option>
                  <option value="Minnesota">Minnesota</option>
                  <option value="Mississippi">Mississippi</option>
                  <option value="Missouri">Missouri</option>
                  <option value="Montana">Montana</option>
                  <option value="Nebraska">Nebraska</option>
                  <option value="Nevada">Nevada</option>
                  <option value="New Hampshire">New Hampshire</option>
                  <option value="New Jersey">New Jersey</option>
                  <option value="New Mexico">New Mexico</option>
                  <option value="New York">New York</option>
                  <option value="North Carolina">North Carolina</option>
                  <option value="North Dakota">North Dakota</option>
                  <option value="Ohio">Ohio</option>
                  <option value="Oklahoma">Oklahoma</option>
                  <option value="Oregon">Oregon</option>
                  <option value="Pennsylvania">Pennsylvania</option>
                  <option value="Rhode Island">Rhode Island</option>
                  <option value="South Carolina">South Carolina</option>
                  <option value="South Dakota">South Dakota</option>
                  <option value="Tennessee">Tennessee</option>
                  <option value="Texas">Texas</option>
                  <option value="Utah">Utah</option>
                  <option value="Vermont">Vermont</option>
                  <option value="Virginia">Virginia</option>
                  <option value="Washington">Washington</option>
                  <option value="West Virginia">West Virginia</option>
                  <option value="Wisconsin">Wisconsin</option>
                  <option value="Wyoming">Wyoming</option>
                </select>
              </div>
            </div>
            <button type="button" class="popup-change-state-btn button--primary">Change State</button>
          </state-estimator>
        </div>
      </div>
    `;

    // Add optimized CSS inline to avoid additional HTTP request
    const optimizedCSS = `
      <style id="age-check-css">
        .modal-prompt {
          background: #fff;
          border-radius: 2px;
          box-shadow: 0px 0px 10px rgba(0,0,0,0.5);
          width: 330px;
          height: auto;
          margin: 0 auto;
          padding: 20px 35px 30px 35px;
          position: relative;
          top: 25%;
          z-index: 1000000;
        }
        .age_popup_title {
          color: #282828;
          display: block;
          padding-bottom: 10px;
          border-bottom: 1px solid #ccc;
          text-align: center;
          font-size: 24px;
        }
        .adult_text {
          color:#424141;
          font-size: 16px;
          text-align: center;
        }
        .adult_text span {
          color: #915395;
          font-weight: 700;
        }
        #prompt-background {
          backdrop-filter: blur(5px);
          width: 100%;
          height: 100%;
          position: fixed;
          left: 0;
          top: 0;
          z-index: 9999999;
        }
        .btn-col {
          display: flex;
          flex-direction: row;
          gap: 5px;
          justify-content: space-between;
        }
        #submit_birthdate {
          flex: 0 0 calc((100% - 5px) / 2);
          font-size: 14px;
          display: block;
          padding: 10px 5px;
          text-align: center;
          background: #915395;
          color:#fff;
          opacity: .7;
        }
        #submit_birthdate:hover {
          opacity: 1;
        }
        #under_button {
          flex: 0 0 calc((100% - 5px) / 2);
          font-size: 14px;
          display: block;
          padding: 10px 5px;
          text-align: center;
          background: #EBEBEA;
        }
        #popup-states {
          display: flex;
          flex-direction: column;
          margin-top: 20px;
        }
        .select-wrapper {height: 52px!Important;}
        .popup-change-state-btn {
          margin-top: 10px;
          padding: 10px 20px;
          background: #915395;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          opacity: 0.8;
          transition: opacity 0.3s ease;
        }
        .popup-change-state-btn:hover {
          opacity: 1;
        }
      </style>
    `;

    // Insert CSS and HTML
    document.head.insertAdjacentHTML('beforeend', optimizedCSS);
    document.body.insertAdjacentHTML('beforeend', popupHTML);
    document.body.style.overflow = 'hidden';
    
    // Set up event listeners
    setupEventListeners();
    
    // Load geolocation with better performance
    loadGeolocationOptimized();
  }

  function setupEventListeners() {
    document.getElementById('submit_birthdate').addEventListener('click', handleYes);
    document.getElementById('under_button').addEventListener('click', handleNo);
    
    // Add event listener for Change State button
    const changeStateBtn = document.querySelector('.popup-change-state-btn');
    if (changeStateBtn) {
      changeStateBtn.addEventListener('click', handleStateChange);
    }
  }

  function handleYes() {
    // Save the selected state first
    saveSelectedState();
    
    // Set cookie with longer expiry for better UX
    const days = 30; // Increased from 14 to 30 days
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `isAnAdult=true; expires=${date.toGMTString()}; path=/; SameSite=Strict`;
    
    // Hide modal and restore scrolling
    const background = document.getElementById('prompt-background');
    const css = document.getElementById('age-check-css');
    if (background) background.remove();
    if (css) css.remove();
    document.body.style.overflow = '';
    
    // Update header state display
    updateHeaderStateAlways();
  }

  function handleStateChange() {
    // Save the selected state when Change State button is clicked
    saveSelectedState();
    updateHeaderStateAlways();
  }

  function saveSelectedState() {
    const stateSelector = document.getElementById('popup_state_selector');
    if (stateSelector && stateSelector.value) {
      const selectedState = stateSelector.value;
      const expiry = Date.now() + (7 * 24 * 60 * 60 * 1000); // 7 days
      localStorage.setItem('currentState', selectedState);
      localStorage.setItem('stateExpiry', expiry.toString());
    }
  }


  function handleNo() {
    const adultText = document.querySelector('.adult_text');
    if (adultText) {
      adultText.style.color = 'red';
    }
    // Redirect after delay
    setTimeout(() => {
      window.location.href = 'https://google.com';
    }, 1000);
  }

  function loadGeolocationOptimized() {
    // Check cache first with better logic
    const cachedState = localStorage.getItem('currentState');
    const cacheExpiry = localStorage.getItem('stateExpiry');
    const now = Date.now();
    
    // Cache for 7 days instead of 24 hours for better performance
    const cacheDuration = 7 * 24 * 60 * 60 * 1000;
    
    if (cachedState && cacheExpiry && now < parseInt(cacheExpiry)) {
      setStateSelector(cachedState);
      return;
    }
    
    // Use requestIdleCallback for non-critical geolocation
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        fetchGeolocation();
      }, { timeout: 2000 });
    } else {
      setTimeout(fetchGeolocation, 100);
    }
  }

  function fetchGeolocation() {
    // Use a more reliable and faster geolocation service
    fetch('https://ipapi.co/json/', {
      method: 'GET',
      timeout: 3000 // 3 second timeout
    })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      if (data.region) {
        setStateSelector(data.region);
        // Cache for 7 days
        const expiry = Date.now() + (7 * 24 * 60 * 60 * 1000);
        localStorage.setItem('currentState', data.region);
        localStorage.setItem('stateExpiry', expiry.toString());
      }
    })
    .catch(error => {
      console.log('Geolocation failed, using default state');
      // Silently fail - geolocation is not critical
    });
  }

  function setStateSelector(state) {
    const select = document.getElementById('popup_state_selector');
    if (select) {
      const option = Array.from(select.options).find(opt => opt.text === state);
      if (option) {
        option.selected = true;
      }
    }
  }

  // Initialize with performance optimization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeCheck);
  } else {
    // Use requestIdleCallback for better performance
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initAgeCheck);
    } else {
      setTimeout(initAgeCheck, 0);
    }
  }
})();
